import React, { Component } from 'react';
import Footer from "../Footer/Footer";
import SideBar from '../SideBar/SideBar';
import Welcome from '../Welcome/Welcome';
import "./ieFIX.scss";
// import "../Services/SwipeEvents";
import { interstitial } from '../Services/Adsense/ads';

class App extends Component {
  componentDidMount() {
    interstitial();
    let ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf("edge") > -1 ||
      ua.indexOf("msie") > -1 ||
      ua.indexOf("rv:11.0") > -1) {
      window.document.querySelector("html").classList.add(`ie`);
      if(ua.indexOf("rv:11.0") > -1)  {
        window.document.querySelector("html").classList.add(`ie11`);
      }
    }
  }
  render() {
    return (
      <div className="App">
        <SideBar />
        <main className="main-wrapper">
          <div className="main-screen">
            <Welcome />
          </div>
        </main>
        <Footer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/Components/App/App.jsx